// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1En-c","itemTitle":"ClientEmergencyInfo_itemTitle__37Q9Z","itemText":"ClientEmergencyInfo_itemText__3cahz"};